import React from 'react';
import SharedConstants from '../../../common/constants/SharedConstants';

/**
 * Multi Select Options Component as grouping the options based on the category
 */
export const MultiSelectOptions = props => {
  const { tabIndex, ariaLable, className, options, onChange, testid = '', selectedValue, ...rest } = props;
  /**
   * On Key Press Handler
   * @param {*} evt - Event Object
   */
  const onKeyPressHandler = evt => {
    // Char Code - Space and Enter
    const { SPACE, ENTER } = SharedConstants.KEY_CHAR_CODE;
    if (onChange && (evt.charCode === SPACE || evt.charCode === ENTER)) {
      onChange();
    }
  };

  const renderOptions = render_options => {
    return render_options.map(option => {
      return (
        <option key={option.value} value={option.value} title={option.category} data-testid='sort-visit-option'>
          {option.value}
        </option>
      );
    });
  };

  return (
    <select
      className={className}
      tabIndex={tabIndex}
      aria-label={ariaLable}
      onChange={onChange}
      onKeyPress={onKeyPressHandler}
      data-testid={testid}
      defaultValue={selectedValue}
      {...rest}
    >
      <option>{SharedConstants.DROPDOWN_DEFAULT_VALUE}</option>
      {Object.keys(options).map((group, index) => {
        return (
          <optgroup key={index} label={group} data-testid='sort-visit-group'>
            {renderOptions(options[group])}
          </optgroup>
        );
      })}
    </select>
  );
};

export default MultiSelectOptions;
